export const movieSortValue = {
  popularity: "popularity.desc",
  top_rated: "vote_count.desc",
  now_playing: "primary_release_date.desc"
}